module.exports = __webpack_public_path__ + "img/lb_gebouw.b97f96b2.svg";